/*
 * Eraya price-test bridge (Horizon).
 * The SDK only scans at init, so re-apply test prices when the theme changes cards:
 *  - card swatch change (shopify:product:select, resolves after the theme's own morph)
 *  - AJAX-injected cards (predictive search, recommendations, filters, infinite scroll)
 * PDP is not handled here: duplicate-product tests redirect off the original PDP.
 */
(function () {
  'use strict';

  function getManager() {
    try {
      var E = window.Eraya;
      if (E && E.sdk && typeof E.sdk.getPriceTestManager === 'function') return E.sdk.getPriceTestManager();
    } catch (_) {}
    return null;
  }

  document.addEventListener('shopify:product:select', function (event) {
    if (!event.promise) return;
    event.promise.then(function (result) {
      var detail = result && result.detail;
      var variant = (detail && detail.resource) || (result && result.variant);
      var productId = detail && detail.productId;
      if (!variant || !variant.id || !productId) return;
      productId = String(productId);
      var variantId = String(variant.id);
      document.querySelectorAll('[data-product-id="' + productId + '"]').forEach(function (el) {
        if (el.hasAttribute('data-variant-id')) el.setAttribute('data-variant-id', variantId);
      });
      var mgr = getManager();
      if (mgr && typeof mgr.updatePricesForProduct === 'function') {
        try { mgr.updatePricesForProduct(productId, variantId); } catch (_) {}
      }
    }).catch(function () {});
  });

  function rescan() {
    var mgr = getManager();
    if (mgr && typeof mgr.updatePricesOnCurrentPage === 'function') {
      try { mgr.updatePricesOnCurrentPage(); } catch (_) {}
    }
  }

  function isCardNode(n) {
    if (n.nodeType !== 1) return false;
    if (n.hasAttribute('data-product-id') || n.classList.contains('price')) return true;
    return n.querySelector('[data-product-id], .price') !== null;
  }

  // childList only (never attributes/characterData) so the engine's own text rewrites don't re-trigger.
  // Runs in the observer microtask, i.e. before paint, so injected cards don't flash the original price.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (isCardNode(added[j])) { rescan(); return; }
      }
    }
  });

  function start() { observer.observe(document.body, { childList: true, subtree: true }); }
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
